"use client"
import { Box, Button, ButtonGroup, Paper, Typography } from "@mui/material"
import { BarChartWithScroll } from "./bar-chart-with-scroll"
import { Provider } from "../../store/slices/provider"
import { DataListV2 } from "./data-list-v2"
import { useState } from "react"


interface ProvidersBlockProps {
  providers: Provider[]
  onProviderSelect?: (provider: Provider) => void
  selectedProviderId?: string;
  selectedCoin: 'USD' | 'PEN';
  currentView: 'Tabla' | 'Gráfico';
  setCurrentView: (value: 'Tabla' | 'Gráfico') => void;
}

export function ProvidersBlock({
  providers,
  onProviderSelect,
  selectedProviderId,
  selectedCoin,
  currentView,
  setCurrentView,
}: ProvidersBlockProps) {
  
  const [scrollIndex, setScrollIndex] = useState(0)

  const sortedProviders = [...providers]
    .map(p => ({ 
      ...p,
      id: p.CodProveedor, 
      name: p.Descripcion, 
      amount: p[`Costo${selectedCoin}`], 
    }))
    // .sort((a, b) => b.amount - a.amount)

  return (
    <Paper
      elevation={1}
      sx={{
        padding: 3,
        backgroundColor: "var(--background)",
        borderRadius: "var(--radius)",
        height: "40vh",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Box 
        sx={{ 
          display: "grid",
          gridTemplateColumns: "40% 1fr",
          gap: 3,
          flex: 1,
          maxHeight: '2em'
        }}
      >
        <Typography
          variant="h6"
          sx={{
            fontWeight: 700,
            color: "var(--foreground)",
            marginBottom: 1,
          }}
        >
          Facturación por proveedor
        </Typography>
        <ButtonGroup size="small" variant="outlined" style={{maxHeight: '1.5em'}}>
          {['Tabla', 'Gráfico'].map((m: any) => (
            <Button
              key={m}
              onClick={() => setCurrentView(m)}
              variant={currentView === m ? 'contained' : 'outlined'}
            >
              {m}
            </Button>
          ))}
        </ButtonGroup>
      </Box>

      <Box
        sx={{
          display: "grid",
          // gridTemplateColumns: "25% 1fr",
          gap: 3,
          flex: 1,
          minHeight: 0,
        }}
      >
        {currentView === 'Tabla' && <Box sx={{ minHeight: 0 }}>
          <DataListV2
            data={sortedProviders}
            columns={[
              { label: 'RUC', value: 'RUC', width: '10%'},
              { label: 'Proveedor', value: 'Descripcion', width: '30%'},
              { label: 'Abreviatura', value: 'Abreviatura', width: '15%'},
              { label: 'Correo Corporativo', value: 'EMail', width: '15%'},
              // { label: 'Fecha Actualización', value: 'FechaActualizacion', formatValue: (val) => new Date(val).toLocaleDateString(), width: '15%'},
              { label: 'Monto S/', value: 'CostoPEN', align: 'right', formatValue: (val) => Number.parseFloat(val).toLocaleString("es-PE", { minimumFractionDigits: 2 }), width: '15%'},
              { label: 'Monto $', value: 'CostoUSD', align: 'right', formatValue: (val) => Number.parseFloat(val).toLocaleString("es-PE", { minimumFractionDigits: 2 }), width: '15%'},
            ]}
            showTotal={false}
            onItemClick={(provider) => onProviderSelect?.(provider)}
            isSelected={(provider) => provider.id === selectedProviderId}
            formatTotal={(total) => `${total.toFixed(2)}`}
            totalFields={[
              {label: 'Total S/', key: 'CostoPEN', value: 0},
              {label: 'Total $', key: 'CostoUSD', value: 0},
            ]}
          />
        </Box>}

        {currentView === 'Gráfico' && <Box sx={{ minHeight: 0 }}>
          <BarChartWithScroll
            scrollIndex={scrollIndex}
            setScrollIndex={setScrollIndex}
            data={sortedProviders}
            selectedItemId={selectedProviderId}
            
            labelField="name"
            valueField="amount"
            visibleItems={10}
            tooltipLabel="Saldo"
            onItemClick={(provider) => onProviderSelect?.(provider)}
            formatValue={(value) =>
              `${Number.parseFloat(value).toLocaleString("es-PE", { minimumFractionDigits: 2 })}`
            }
            barColor="rgba(162, 198, 230)"
          />
        </Box>}
      </Box>
    </Paper>
  )
}
